const sectionCardReviewCss = `
[data-type='section-card-review'] .card-review-wrapper {
  padding-block: 40px;
}

[data-type='section-card-review'] .card-review-container {
  background-color: #eafdd7;
  padding: 16px;
  display: flex;
  gap: 32px;
}

[data-type='section-card-review'] .card-review-container[data-position='left'] {
  flex-direction: row;
}

[data-type='section-card-review'] .card-review-container[data-position='right'] {
  flex-direction: row-reverse;
}

[data-type='section-card-review'] .card-review-container .card-review-left {
  flex: 1;
  background-color: #ffffff;
  box-shadow: 0px 0px 6px 3px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  height: fit-content;
}

[data-type='section-card-review'] .card-review-container .card-review-left .card-review-image {
  width: 100%;
  height: 300px;
  overflow: hidden;
  border-radius: 12px 12px 0 0;
}

[data-type='section-card-review'] .card-review-container .card-review-left .card-review-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container {
  padding: 16px;
}

[data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-text h1,
[data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-text h2,
[data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-text h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 12px 0 !important;
}

[data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-text h1:last-child,
[data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-text h2:last-child,
[data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-text h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-text p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-text p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-name {
  font-weight: bold !important;
  font-size: 16px;
  text-align: center;
  margin-top: 16px !important;
  margin-bottom: 4px !important;
}

[data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-verified {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #00af57;
}

[data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-verified .card-review-verified-icon {
  width: 20px;
  height: 20px;
  color: #00af57;
}

[data-type='section-card-review'] .card-review-container .card-review-right {
  flex: 1;
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #c4c4c4;
  margin-bottom: 16px !important;
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars svg {
  fill: #c4c4c4;
  width: 20px;
  height: 20px;
  transition: all 0.2s ease;
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='1'] svg:nth-child(-n + 2),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='1.0'] svg:nth-child(-n + 2),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='2'] svg:nth-child(-n + 3),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='2.0'] svg:nth-child(-n + 3),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='3'] svg:nth-child(-n + 4),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='3.0'] svg:nth-child(-n + 4),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='4'] svg:nth-child(-n + 5),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='4.0'] svg:nth-child(-n + 5),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='5'] svg:nth-child(-n + 6),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-full-stars='5.0'] svg:nth-child(-n + 6) {
  color: #f0b100;
  fill: #f0b100;
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='1'] svg:nth-child(2),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='1.0'] svg:nth-child(2),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='2'] svg:nth-child(3),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='2.0'] svg:nth-child(3),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='3'] svg:nth-child(4),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='3.0'] svg:nth-child(4),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='4'] svg:nth-child(5),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='4.0'] svg:nth-child(5),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='5'] svg:nth-child(6),
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-wrap-stars[data-half-star='5.0'] svg:nth-child(6) {
  stroke: #f0b100;
  fill: url(#half-star-gradient-infinite);
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-content h1,
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-content h2,
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-content h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-content p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-list .card-review-item {
  display: flex;
  align-items: center;
  gap: 16px;
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-image {
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 50%;
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-list .card-review-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text {
  flex: 1;
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text h1,
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text h2,
[data-type='section-card-review'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 12px 0 !important;
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text p {
  font-size: 16px;
  margin-bottom: 4px !important;
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-footer {
  margin-top: 20px !important;
}

[data-type='section-card-review'] .card-review-container .card-review-right .card-review-footer p {
  font-size: 16px;
  margin-bottom: 12px !important;
}

@container (max-width: 768px) {
  [data-type='section-card-review'] .card-review-wrapper {
    padding-block: 16px;
  }

  [data-type='section-card-review'] .card-review-container {
    padding: 8px;
  }

  [data-type='section-card-review'] .card-review-container[data-position='left'],
  [data-type='section-card-review'] .card-review-container[data-position='right'] {
    flex-direction: column;
  }

  [data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-text h1,
  [data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-text h2,
  [data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-text h3,
  [data-type='section-card-review'] .card-review-container .card-review-right .card-review-content h1,
  [data-type='section-card-review'] .card-review-container .card-review-right .card-review-content h2,
  [data-type='section-card-review'] .card-review-container .card-review-right .card-review-content h3,
  [data-type='section-card-review'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text h1,
  [data-type='section-card-review'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text h2,
  [data-type='section-card-review'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-text p,
  [data-type='section-card-review'] .card-review-container .card-review-right .card-review-content p,
  [data-type='section-card-review'] .card-review-container .card-review-right .card-review-list .card-review-item .card-review-item-text p,
  [data-type='section-card-review'] .card-review-container .card-review-right .card-review-footer p {
    font-size: 14px;
  }

  [data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-name,
  [data-type='section-card-review'] .card-review-container .card-review-left .card-review-text-container .card-review-verified {
    font-size: 14px;
  }

  [data-type='section-card-review'] .card-review-container .card-review-right .card-review-list .card-review-item {
    font-size: 14px;
  }
}
`;
export default sectionCardReviewCss;
